/** Low-level SVG helpers used by all chart renderers. */
import { displayDigits } from '../../utils/displayDigits';

export function svgEl(tag: string, attrs?: Record<string, string | number>): SVGElement {
  const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  if (attrs) Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  return el;
}

export function polyPath(pts: [number, number][]): string {
  return pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
}

export function fmtMin(m: number): string {
  const minutes = Math.max(0, Math.round(m));
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}

export function fmtK(v: number): string {
  return v >= 1000 ? `${(v / 1000).toFixed(1)}k` : String(Math.round(v));
}

export function gridLine(svg: SVGElement, x1: number, y1: number, x2: number, y2: number): void {
  svg.appendChild(svgEl('line', {
    x1, y1, x2, y2,
    stroke: 'var(--chart-grid, rgba(255,255,255,.06))', 'stroke-width': 1, 'stroke-dasharray': '3 6',
  }));
}

export function axisLabel(
  svg: SVGElement,
  x: number,
  y: number,
  text: string,
  anchor: 'start' | 'middle' | 'end' = 'end',
): void {
  const t = svgEl('text', {
    x, y, 'text-anchor': anchor,
    'font-size': 9, 'font-weight': 600, fill: 'var(--chart-label, #3A4257)',
    'font-family': 'var(--font-body, sans-serif)', 'letter-spacing': '0',
  });
  t.textContent = displayDigits(text);
  svg.appendChild(t);
}
